import VInput from './VInput'

export { VInput }
export default VInput



// WEBPACK FOOTER //
// ../../../src/components/VInput/index.ts